<template>
  <div class="ui left aligned container">
    <form class="ui form">
      <div class="field">
        <label>用户Cookie</label>
        <textarea name="cookie" v-model="cookie"/>
      </div>
      <button class="ui primary button" @click.prevent="submit">添加</button>
    </form>
    <vuetable ref="vuetable"
              api-url="/weibo/users"
              :fields="fields"
              :perPage="10"
              @vuetable:pagination-data="onPaginationData"
    >
      <template slot="status" scope="props">
        <i class="toggle link icon" :class="[props.rowData.disabled?'off':'on']" title="切换状态" @click="toggle(props.rowData)"></i>
      </template>
      <template slot="actions" scope="props">
        <i class="refresh link icon" title="刷新" @click="check(props.rowData)"></i>
      </template>
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
  </div>
</template>

<script>
import axios from 'axios'
import Vuetable from "@/table/Vuetable";
import VuetablePagination from "@/table/VuetablePagination";

export default {
  name: "WeiboUser",
  components: {
    Vuetable,
    VuetablePagination,
  },
  data() {
    return {
      cookie: '',
      fields: [
        {name: 'id', title: '微博ID', callback: 'link'},
        {name: 'name', title: '微博昵称'},
        {name: 'csrf', title: 'CSRF'},
        {name: '__slot:status', title: '状态'},
        {name: 'valid', title: '有效'},
        {name: '__slot:actions', title: '刷新'}
      ],
    }
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    link(value) {
      return '<a href="https://weibo.com/u/' + value + '" target="_blank">' + value + '</a>'
    },
    toggle(item) {
      axios.post('/weibo/users/' + item.id + '/toggle').then(() => {
        this.$refs.vuetable.reload()
      })
    },
    check(item) {
      axios.post('/weibo/users/' + item.id + '/check').then(() => {
        this.$refs.vuetable.reload()
      })
    },
    submit() {
      if (!this.cookie) {
        return
      }
      const data = {
        cookie: this.cookie
      }
      axios.post('/weibo/users', data).then(() => {
        this.cookie = ''
        this.$refs.vuetable.reload()
      })
    }
  }
}
</script>

<style scoped>

</style>